import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';
import { useUserSuggestions } from '@confluence/share-and-restrict-dialog/entry-points/useUserSuggestions.ts';
import { useCallback, useMemo } from 'react';
import { ShareAndRestrictDialogController } from '@confluence/share-and-restrict-dialog/entry-points/ShareAndRestrictDialogController.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { expValEquals } from '@confluence/feature-experiments';

export const useShareLinkSocialOnPublish = (
	contentId: string,
	spaceKey: string,
	userId: string | null,
	skip: boolean = false,
) => {
	const userIdArray = useMemo(() => (userId ? [userId] : []), [userId]);

	const { cloudId, orgId } = useSessionData();

	const { suggestedUsers, loading } = useUserSuggestions({
		currentPickedPrincipalIds: userIdArray,
		maxDisplayResults: 3,
		orgId,
		siteId: cloudId,
		skip,
	});

	const { showModal } = useDialogs();

	const showShareModal = useCallback(() => {
		showModal(ShareAndRestrictDialogController, {
			contentId,
			contentType: 'page',
			allowRestrictions: true,
			pageModes: 'view',
			refetchButtonData: () => {},
			isUnpublishedDraft: false,
			spaceKey,
			defaultSuggestedUsers: suggestedUsers || [],
		});
	}, [showModal, contentId, spaceKey, suggestedUsers]);

	const isEligible = useMemo(() => {
		return !loading && suggestedUsers !== null && suggestedUsers.length > 0;
	}, [suggestedUsers, loading]);

	const memoizedSuggestedUsers = useMemo(() => {
		return suggestedUsers || [];
	}, [suggestedUsers]);

	return {
		isEligible,
		suggestedUsers: expValEquals('confluence_edit_page_rerender_optimizations', 'isEnabled', true)
			? memoizedSuggestedUsers
			: suggestedUsers || [],
		showShareModal,
	};
};
